import { render } from "./ModalUsuariosBorrar.vue?vue&type=template&id=70812e3b"
import script from "./ModalUsuariosBorrar.vue?vue&type=script&lang=js"
export * from "./ModalUsuariosBorrar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__